import { userConstants } from '../_constants';

let user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}user`));

// Clean state: no session. This is the state we return to upon logout or session expiry.
const cleanState = {
  loggingIn: false,
  loggedIn: false,
  user: null,
  validToken: false,
  sessionExpired: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': ''
  },
  cache: 'no-store',
  currentUrl: null
};

// Start-up state: if there was a user in localStorage when the page loaded, we retain that information.
const bootstrapState = user ? {
  loggedIn: true,
  user,
  validToken: true,
  headers: user.headers,
  currentUrl: null
} : cleanState;

export function authentication(state = bootstrapState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      if (state.currentUrl) {
        console.log(state.currentUrl)
      }
      return {
        ...state,
        loggingIn: true,
        user: action.user,
        validToken: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + action.user.token
        },
        cache: 'no-store'
      };

    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        user: action.user,
        validToken: true,
        sessionExpired: false,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + action.user.token
        },
        cache: 'no-store'
      };

    case 'TOKEN_VALIDATED':
      if (action.payload) {
        return { ...state, validToken: true }
      } else {
        localStorage.removeItem(`${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}user`);
        return { ...cleanState, sessionExpired: true };
      }

    case 'TOKEN_UNAUTHORISED':
      localStorage.removeItem(`${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}user`);
      return { ...cleanState, sessionExpired: true };

    case 'TOKEN_REFRESHED': {
      // If there is no current user, there is no point in refreshing tokens
      if (!state.user) {
        //console.warn('TOKEN_REFRESHED dispatched without an active user, ignoring');
        return state;
      }

      const updatedUser = {
        ...state.user,
        token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        headers: {
          ...state.user.headers,
          'Authorization': 'Bearer ' + action.payload.access_token
        }
      };

      // Additional validation: do not proceed if the new tokens are invalid
      if (!updatedUser.token || !updatedUser.refresh_token) {
        //console.warn('TOKEN_REFRESHED with incomplete tokens, ignoring');
        return state;
      }

      localStorage.setItem(
        `${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}user`,
        JSON.stringify(updatedUser)
      );

      return {
        ...state,
        user: updatedUser,
        validToken: true,
        sessionExpired: false,
        headers: {
          ...state.headers,
          'Authorization': 'Bearer ' + action.payload.access_token
        }
      };
    }

    case userConstants.LOGIN_FAILURE:
      return cleanState;

    case userConstants.LOGOUT:
      return cleanState;

    default:
      return state
  }
}